import { render, staticRenderFns } from "./CustomerTerms.vue?vue&type=template&id=ab6dfa20&scoped=true&"
import script from "./CustomerTerms.vue?vue&type=script&lang=js&"
export * from "./CustomerTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6dfa20",
  null
  
)

export default component.exports